import { Mail, MapPin, MessageCircle, Phone } from "lucide-react";
import { PageHero, SectionHead } from "../components/site/PageHero";
import { CaseForm } from "../components/forms/CaseForm";
import { GRIEVANCE_CATEGORIES, ORG, whatsappLink } from "../data/content";

const Item = ({ icon: Icon, label, children, testId }) => (
  <div className="flex gap-4 rounded-xl border border-slate-200 bg-white p-5" data-testid={testId}>
    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-royal-light text-royal"><Icon className="h-5 w-5" /></span>
    <div><p className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</p><div className="mt-1 text-sm font-semibold text-navy">{children}</div></div>
  </div>
);

export default function Contact() {
  return (
    <>
      <PageHero eyebrow="Contact Us" title="Contact the Federation" subtitle="Reach the federation office for membership, grievances, legal support or general enquiries." image="/images/kozhikode-lake.jpg" testId="contact-hero" />
      <section className="py-16 md:py-24">
        <div className="container-x grid gap-10 lg:grid-cols-12">
          <div className="space-y-4 lg:col-span-5">
            <SectionHead eyebrow="Official communication" title="Federation Office" />
            <div className="space-y-4 pt-4">
              <Item icon={MapPin} label="Office address" testId="contact-address">{ORG.address}</Item>
              <Item icon={Phone} label="Contact number" testId="contact-phone"><a href={`tel:+91${ORG.phone}`} className="hover:text-royal">{ORG.phoneDisplay}</a></Item>
              <Item icon={Mail} label="Email" testId="contact-email"><a href={`mailto:${ORG.email}`} className="hover:text-royal">{ORG.email}</a></Item>
            </div>
            <a href={whatsappLink()} target="_blank" rel="noreferrer" className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-[#25D366] px-6 py-3.5 text-sm font-bold text-white transition-opacity hover:opacity-90" data-testid="contact-whatsapp-button">
              <MessageCircle className="h-5 w-5" /> WhatsApp Enquiry
            </a>
          </div>
          <div className="overflow-hidden rounded-2xl border border-slate-200 lg:col-span-7" data-testid="contact-map">
            <iframe title="Federation office location" className="h-full min-h-[420px] w-full" loading="lazy" referrerPolicy="no-referrer-when-downgrade"
              src={`https://maps.google.com/maps?q=${encodeURIComponent(ORG.mapQuery)}&z=16&output=embed`} />
          </div>
        </div>
      </section>
      <section id="grievance" className="scroll-mt-28 bg-slate-100/70 py-16 md:py-24">
        <div className="container-x grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHead eyebrow="Online Grievance Registration" title="Register a workplace grievance" text="Describe your issue in confidence. You will receive a reference number, and the federation office will review your grievance." />
          </div>
          <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8 lg:col-span-8">
            <CaseForm kind="grievance" categories={GRIEVANCE_CATEGORIES} submitLabel="SUBMIT GRIEVANCE" />
          </div>
        </div>
      </section>
    </>
  );
}
